import React from 'react'
import Card from "@material-ui/core/Card";

const styles = {
    card: {
        fontSize: '14px',
        border: 'none',
        boxShadow: 'none',
        fontWeight: '500',
        display: 'flex',
        lineHeight: '1.4em',
        justifyContent: 'center',
        height: '100vh',
        alignItems: 'center',
        flexWrap: 'wrap',
        alignContent: 'center'
    },
    legend_block: {
        textAlign: 'center',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    legend: {
        width: '70%',
    },
    phone_image: {
        width: '5em',
        marginTop: '5em'
    },
};


export const BookingNotAvailable = ({phone}) => (
    <Card style={styles.card}>
        <div style={styles.legend_block}>
            <div style={styles.legend}>
            Студия не подключила онлайн бронирование. Если Вы хотите бронировать ее онлайн через TONESKY — сообщите
            студии об этом.
            </div>
        </div>
        {phone ?
            <div>
                <a href={`tel:+${phone}`}>
                    <img style={styles.phone_image} alt="phone-icon"
                         src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/phone.png'}/>
                </a>
            </div> : ''}
    </Card>
);



